const state = {
  currentEntry: null,
  currentEntryHoursRemaining: null
}

const mutations = {
  updateCurrentEntry (state, entryObject) {
    state.currentEntry = entryObject
  },
  updateCurrentEntryHoursRemaining (state, hours) {
    state.currentEntryHoursRemaining = hours
  }
}

const getters = {
  currentEntry: state => {
    return state.currentEntry
  },
  currentEntryHoursRemaining: state => state.currentEntryHoursRemaining
}

export default {
  state,
  mutations,
  getters
}
